import { Empty, Modal, Result, Select, Button as AntdButton } from 'antd'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getCachedGuests, mergeGuests } from 'services/guests.services'
import GuestDropdown from './GuestDropdown'
import GuestDetails from './GuestDetails'
import { Button } from 'components/Buttons/Buttons'
import { openNotificationWithIcon } from 'utils/Notification'
import { push } from 'connected-react-router'

export const Preference = {
    Primary: 1,
    Secondary: 2
}

export default function Merge() {

    const dispatch = useDispatch()
    const user = useSelector((state) => state.user?.currentUser);

    const hasMergePermission = useMemo(() => {
        return user?.permissions?.find(
            (permission) => permission.permissionName === "Merge Profile"
        );
    }, [user]);


    const [primaryGuestId, setPrimaryGuestId] = useState(null)
    const [secondaryGuestId, setSecondaryGuestId] = useState(null)

    const [showSuccessMessage, setShowSuccessMessage] = useState(false)

    const [basicInforPreferences, setBasicInfoPreferences] = useState({
        userName: Preference.Primary,
        email: Preference.Primary,
        dob: Preference.Primary,
        flag: Preference.Primary,
    })

    const [selectedAddresses1, setSelectedAddresses1] = useState([])
    const [selectedAddresses2, setSelectedAddresses2] = useState([])
    const [selectedPrimaryAddress, setSelectedPrimaryAddress] = useState(null)

    const [selectedFiles1, setSelectedFiles1] = useState([])
    const [selectedFiles2, setSelectedFiles2] = useState([])

    const primaryGuestBasicDetails = useRef(null)
    const secondaryGuestBasicDetails = useRef(null)

    useEffect(() => {
        setSelectedAddresses1([])
        setSelectedFiles1([])
    }, [primaryGuestId])

    useEffect(() => {
        setSelectedAddresses2([])
        setSelectedFiles2([])
    }, [secondaryGuestId])

    async function handleSubmit() {

        if (!primaryGuestId || !secondaryGuestId) {
            return
        }

        if (primaryGuestId === secondaryGuestId) {
            openNotificationWithIcon('error', "Error", "Both guests are same")

            return
        }


        const userName = basicInforPreferences.userName === Preference?.Primary
            ? primaryGuestBasicDetails?.current?.userName : secondaryGuestBasicDetails?.current?.userName
        const email = basicInforPreferences.email === Preference?.Primary
            ? primaryGuestBasicDetails?.current?.email : secondaryGuestBasicDetails?.current?.email
        const dob = basicInforPreferences.dob === Preference?.Primary
            ? primaryGuestBasicDetails?.current?.dob : secondaryGuestBasicDetails?.current?.dob
        const isFlagged = basicInforPreferences.flag === Preference?.Primary
            ? primaryGuestBasicDetails?.current?.flag : secondaryGuestBasicDetails?.current?.flag

        const firstName = primaryGuestBasicDetails?.current?.firstName
        const lastName = primaryGuestBasicDetails?.current?.lastName
        const phoneNumber = primaryGuestBasicDetails?.current?.phoneNumber


        const addressIds = [...selectedAddresses1, ...selectedAddresses2]
        const isPrimaryAddressFound = addressIds.includes(selectedPrimaryAddress)




        if (userName == null || email == null || dob == null || isFlagged == null) {
            openNotificationWithIcon('error', "Error", "Basic information missing")
            return
        }

        if (!isPrimaryAddressFound) {
            openNotificationWithIcon('error', "Error", "No primary address selected")
            return
        }

        const res = await dispatch(mergeGuests(primaryGuestId, secondaryGuestId, {
            userName, email, dob, isFlagged,
            firstName, lastName, phoneNumber,
            selectedAddressIds: addressIds,
            primaryContactId: selectedPrimaryAddress,
            selectedDocumentIds: [...selectedFiles1, ...selectedFiles2]
        }))

        if (res?.status === 'success') {
            setShowSuccessMessage(true)
            setPrimaryGuestId()
            setSecondaryGuestId()
            setBasicInfoPreferences(
                {
                    userName: Preference.Primary,
                    email: Preference.Primary,
                    dob: Preference.Primary,
                    flag: Preference.Primary,
                }
            )
        }

    }

    if (showSuccessMessage) {
        return <Result
            status="success"
            title="Profiles Merged Successfully"
            // subTitle="Order number: 2017182818828182881 Cloud server configuration takes 1-5 minutes, please wait."
            extra={[
                <AntdButton rounded type="text" key="console"
                    onClick={() => {
                        dispatch(push('/dashboard/guests'))
                    }}>
                    Go to guests page
                </AntdButton>,
                <Button rounded key="buy" onClick={() => {
                    setShowSuccessMessage(false)
                }}>Merge another profile</Button>,
            ]}
        />
    }

    return (
        <div

            style={{
                height: '100%',
                overflow: 'hidden',
                overflowY: 'auto',
                paddingBottom: 32
            }}
        >
            {/* <div>
                Select two guests
            </div> */}


            <div
                style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(2, 1fr)',
                    alignItems: 'start',
                    marginBottom: 16,
                    padding: 12,
                }}
            >
                {/* <div style={{ padding: '0 16px' }}>
                    Select guests
                </div> */}
                <div style={{
                    padding: '0 8px',
                    paddingRight: 16,
                    borderRight: "1px solid #e6e6e6",
                    minHeight: '300px'
                }}>
                    <div style={{ marginBottom: 16 }}>
                        <div style={{ fontFamily: 'tradeGothic', fontWeight: 600, marginBottom: 4, color: '#486baf' }}>Primary Guest</div>
                        <GuestDropdown
                            value={primaryGuestId}
                            onChange={setPrimaryGuestId}
                            placeholder="Select Primary Guest"
                        // disableGuestId={secondaryGuestId}
                        />
                    </div>

                    <div style={{ padding: '0 ' }}>
                        {
                            primaryGuestId && <GuestDetails
                                customerId={primaryGuestId}
                                isPrimary={true}
                                basicInforPreferences={basicInforPreferences}
                                onBasicInfoPreferenceChange={(fieldName, value) => {
                                    setBasicInfoPreferences(state => ({
                                        ...state,
                                        [fieldName]: value
                                    }))
                                }}

                                addresses={selectedAddresses1}
                                onAddressesChange={setSelectedAddresses1}
                                primaryAddress={selectedPrimaryAddress}
                                onPrimaryAddressChange={setSelectedPrimaryAddress}
                                files={selectedFiles1}
                                onFilesChange={setSelectedFiles1}

                                onLoadGuestDetails={(basicInfo) => {
                                    primaryGuestBasicDetails.current = basicInfo
                                }}
                            />
                        }
                        {
                            !primaryGuestId && <Empty
                                description="No Profile Selected"
                            />
                        }
                    </div>
                </div>

                <div style={{ padding: '0 16px', }}>
                    <div style={{ marginBottom: 16 }}>
                        <div style={{ fontFamily: 'tradeGothic', fontWeight: 600, marginBottom: 4, color: '#486baf' }}>Secondary Guest</div>
                        <GuestDropdown
                            value={secondaryGuestId}
                            onChange={setSecondaryGuestId}
                            placeholder="Select Secondary Guest"
                            disableGuestId={primaryGuestId}
                        />

                    </div>

                    <div style={{ padding: '0 ' }}>
                        {
                            secondaryGuestId &&
                            <GuestDetails
                                customerId={secondaryGuestId}
                                basicInforPreferences={basicInforPreferences}
                                onBasicInfoPreferenceChange={(fieldName, value) => {
                                    setBasicInfoPreferences(state => ({
                                        ...state,
                                        [fieldName]: value
                                    }))
                                }}


                                addresses={selectedAddresses2}
                                onAddressesChange={setSelectedAddresses2}
                                primaryAddress={selectedPrimaryAddress}
                                onPrimaryAddressChange={setSelectedPrimaryAddress}

                                files={selectedFiles2}
                                onFilesChange={setSelectedFiles2}

                                onLoadGuestDetails={(basicInfo) => {
                                    secondaryGuestBasicDetails.current = basicInfo
                                }}
                            />
                        }
                        {
                            !secondaryGuestId && <Empty
                                description="No Profile Selected"
                            />
                        }
                    </div>
                </div>
            </div>



            {
                (primaryGuestId || secondaryGuestId) && <div
                    style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(2, 1fr)',
                        alignItems: 'start',
                    }}
                >
                    {/* <div>

                    </div> */}



                </div>
            }

            <div style={{ padding: "12px 16px", display: 'flex', justifyContent: 'flex-end' }}>
                {/* */}
                {
                    primaryGuestId && secondaryGuestId &&
                    <Button
                        disabled={!hasMergePermission}
                        rounded
                        onClick={() => {
                            showProfileMergeConfirm(
                                {
                                    name: primaryGuestBasicDetails?.current?.firstName + " " + primaryGuestBasicDetails?.current?.lastName,
                                    id: primaryGuestId
                                },
                                {
                                    name: secondaryGuestBasicDetails?.current?.firstName + " " + secondaryGuestBasicDetails?.current?.lastName,
                                    id: secondaryGuestId
                                },
                                () => {
                                    // Handle merge logic here
                                    handleSubmit()
                                }
                            )
                        }}
                    >Merge</Button>
                }
            </div>
        </div>
    )
}


export function showProfileMergeConfirm(survivingProfile, profileToDelete, onConfirm) {
    Modal.confirm({
        title: <div style={{ fontFamily: 'tradeGothic', fontWeight: 600, color: '#000000d9' }}>Confirm Profile Merge</div>,
        content: (
            <div>
                <div style={{ fontFamily: 'tradeGothic', fontWeight: 500 }}>
                    Are you sure you want to merge these profiles? Once completed, the merged account will be
                    permanently deleted. All data will be moved to the surviving profile.
                </div>
                <div style={{ marginTop: '16px', fontFamily: 'tradeGothic', fontWeight: 500 }}>
                    <strong style={{ fontFamily: 'tradeGothic', fontWeight: 600 }}>Surviving Profile:</strong> {survivingProfile.name} (#{survivingProfile.id})<br />
                    <strong style={{ fontFamily: 'tradeGothic', fontWeight: 600 }}> Profile to be Deleted:</strong> {profileToDelete.name} (#{profileToDelete.id})
                </div>
            </div>
        ),
        okText: 'Confirm & Merge',
        cancelText: 'Cancel',
        okButtonProps: {
            style: {
            }
        },
        closable: true,
        maskClosable: true,
        onOk() {
            onConfirm()
        }
    })
}